import useSWR, { preload, SWRConfiguration, SWRResponse } from 'swr';
import { peep_client } from '~/src/api/peep';
import { UuidString } from '~src/utils/UUID';
import { Cohort } from '~src/types/user';

export function useCohort(swr_override: SWRConfiguration = {}): SWRResponse<Cohort> {
  return useSWR(['get_cohort'], () => peep_client.users.getCohort(), {
    ...swr_override,
  });
}

export function useWhoAmI(swr_override: SWRConfiguration = {}): SWRResponse<UuidString> {
  return useSWR(['whoami'], () => peep_client.users.whoami(), {
    ...swr_override,
  });
}
